<template lang="pug">
div
	.card.mb-2
		.card-body.p-0
			.caja-herramientas
				div(:class="(opciones.activoColocacion) ? '' : 'disabled'", @click="ver = 'colocacion'")
					span.fa.fa-puzzle-piece
					div Colocación
				div(:class="(opciones.activoInsertar) ? '' : 'disabled'")
					span.fa.fa-plus-square
					div Insertar Originales
				div(:class="(opciones.activoRotacionV) ? '' : 'disabled'")
					span.fa.fa-arrows-v
					div Rotación vertical
				div(:class="(opciones.activoRotacionH) ? '' : 'disabled'")
					span.fa.fa-arrows-h
					div Rotación horizontal
				div(:class="(opciones.activoAnulaIns) ? '' : 'disabled'")
					span.fa.fa-calendar-times-o
					div Anular inserciones
				div(:class="(opciones.activoRecuperaIns) ? '' : 'disabled'")
					span.fa.fa-calendar-plus-o
					div Recuperar inserciones
				div(:class="(opciones.activoModVarias) ? '' : 'disabled'")
					span.fa.fa-gears
					div Modificar varias
	.radiacion.bg-info.text-white
		div Línea
		div.dia(v-for="dia in dias", :key="dia.getTime()") {{dia.getDate()}}
	.radiacion(
		v-for="linea in contrato.lineas"
		v-if="linea.tipo === 'radio'"
		:class="(lineaSeleccionada === linea.ID_linea) ? 'bg-warning' : ''"
	)
		div(
			style="cursor: pointer"
			@click="seleccionaLinea(linea)"
		)
			span.badge.badge-danger.mr-2(style="font-size:1em;") {{linea.ID_linea}}
			| {{linea.producto}}
			span.badge.badge-info.ml-2 0/{{linea.cantidad}} inserciones
		div.dia(
			v-for="dia in dias",
			:key="linea.ID_linea + '-' + dia.getTime()",
			:class="(dia < contrato.fecha_inicio || dia > contrato.fecha_fin) ? 'dia-inactivo' : 'dia-activo'"
			)

	nav.mt-3
		ul.pagination
			li.page-item(v-for="mes in meses", :key="mes.getTime()", :class="(mesActivo === mes) ? 'active' : ''", @click="mesActivo = mes")
				a.page-link
					span {{nombreMes[mes.getMonth()]}}
					span(v-if="variosAnos") , {{mes.getFullYear()}}
	colocacion(:linea-contrato.sync="lineaSeleccionada", v-if="lineaSeleccionada && ver === 'colocacion'", @cerrar="ver = ''")
</template>

<script>
import Colocacion from './radiacion/colocacion.vue'
export default {
	props: ['contrato'],
	components: {
		colocacion: Colocacion
	},
	data () {
		return {
			nombreMes: [
				'Enero',
				'Febrero',
				'Marzo',
				'Abril',
				'Mayo',
				'Junio',
				'Julio',
				'Agosto',
				'Septiempre',
				'Octubre',
				'Noviembre',
				'Diciembre'
			],
			lineaSeleccionada: null,
			ver: '',
			mesActivo: null
		}
	},
	created () {
		this.mesActivo = this.meses[0]
	},
	computed: {
		opciones () {
			const opt = {
				activoColocacion: false,
				activoInsertar: false,
				activoRotacionV: false,
				activoRotacionH: false,
				activoAnulaIns: false,
				activoRecuperaIns: false,
				activoModVarias: false
			}

			if (this.lineaSeleccionada) {
				opt.activoColocacion = true
				opt.activoInsertar = true
				opt.activoRotacionV = true
				opt.activoRotacionH = true
				opt.activoAnulaIns = true
				opt.activoRecuperaIns = true
			}

			return opt
		},
		dias () {
			if (!this.mesActivo) {
				return []
			}

			const mes = new Date(this.mesActivo.getTime())
			const mesNum = mes.getMonth()
			mes.setDate(1)
			mes.setHours(0)
			mes.setMinutes(0)
			mes.setSeconds(0)
			mes.setMilliseconds(0)

			const dias = []
			while (mesNum === mes.getMonth()) {
				dias.push(new Date(mes.getTime()))
				mes.setDate(mes.getDate() + 1)
			}

			return dias
		},
		meses () {
			const arr = []

			let mes = new Date(this.contrato.fecha_inicio.getTime())
			mes.setDate(1)

			while (mes.getTime() <= this.contrato.fecha_fin.getTime()) {
				arr.push(new Date(mes.getTime()))
				mes.setMonth(mes.getMonth() + 1)
			}

			return arr
		},

		variosAnos () {
			return (
				this.meses[0].getFullYear() !==
				this.meses[this.meses.length - 1].getFullYear()
			)
		}
	},

	methods: {
		seleccionaLinea (linea) {
			this.lineaSeleccionada = linea
		}
	}
}
</script>

<style scoped>
.radiacion {
  display: flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  /* align-items: stretch; */
  align-content: stretch;
  width: 100%;
  border: 1px solid #666666;
  border-bottom: 0;
  background-color: white;
}
.radiacion:last-of-type {
  border-bottom: 1px solid #666666;
}
.radiacion > div {
  flex: 1 auto;
  align-self: auto;
  border-right: 1px solid #666666;
  border-left: none;
  height: 30px;
  line-height: 30px;
  text-overflow: ellipsis;
}
.radiacion > div:last-child {
  border-right: none;
}
.radiacion > div:first-child {
  padding-left: 10px;
}

.radiacion > div.dia {
  max-width: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  text-overflow: ellipsis;
}

.dia-inactivo {
  background-color: #bbbbbb;
}

.dia-activo {
  background-color: white !important;
}

/* HERRAMIENTAS */
.caja-herramientas {
  display: flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  width: 100%;
}

.caja-herramientas > div {
  flex: 1 auto;
  align-self: auto;
  border-left: none;
  width: 80px;
  max-width: 80px;
  height: 80px;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
  margin-right: 5px;
}

.caja-herramientas > div.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.caja-herramientas > div.disabled:hover {
  background-color: inherit;
}

.caja-herramientas > div:hover {
  background-color: darkred;
  color: white;
}

.caja-herramientas > div > span {
  font-size: 2.5em;
}
.caja-herramientas > div > div {
  font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/radiacion.vue